/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { CarryInLocationBase } from "../../../../schema/generated/CarryInLocation";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class CarryInLocationDataApi extends EntityDataApi<CarryInLocationBase> {
  public readonly def = idbEntityDefs.CarryInLocation;
}